// Shared date display helpers — Philippine-friendly, words over digits.
//   fmtDate('2026-01-31')      → "Jan 31, 2026 · Sat"   (default wherever it fits)
//   fmtDateShort('2026-01-31') → "Jan 31 · Sat"          (dense rows / chips)
// Both accept plain YYYY-MM-DD or full ISO timestamps. Anything unparseable is
// returned unchanged so a bad value can never blank out a page. Parsing uses
// the local-time constructor — never the Date ISO parser — so PH (UTC+8) users
// don't see the previous day.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DOWS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function parseYmd(ds) {
  if (!ds || typeof ds !== 'string') return null;
  const m = ds.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDate(ds) {
  const d = parseYmd(ds);
  return d ? `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} · ${DOWS[d.getDay()]}` : (ds || '');
}

export function fmtDateShort(ds) {
  const d = parseYmd(ds);
  return d ? `${MONTHS[d.getMonth()]} ${d.getDate()} · ${DOWS[d.getDay()]}` : (ds || '');
}
